// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__16gSv","app__sidebar":"App_app__sidebar__ViMxK","app__content":"App_app__content__2nJtr","fadeIn":"App_fadeIn__RQN5Z"};